import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { SortDirection } from '~/types';
import { useResourceAllocationUpdateHandler } from '~/modules/quickAllocation/components/QuickAllocationUserChart/hooks';
import { ResourceAllocationPeriodEditPopoverDetails } from '~/modules/resourcing/common/components';
import getAllocationPeriodEditorDateRange from '~/modules/resourcing/common/components/ResourceAllocationPeriodEditPopover/components/ResourceAllocationEditor/getAllocationPeriodEditorDateRange';
import { getScheduleTotalHours } from '~/modules/resourcing/common/util';

export const EditQuickAllocationPeriod = ({
  scale,
  chartStartDate,
  chartEndDate,
  allocationPeriodEditTarget,
  handleAllocationPeriodClose,
  setPreviousPeriod,
  setNextPeriod,
  allocationSort,
  openReleaseResourcesDialog
}) => {
  const { resourceAllocation } = allocationPeriodEditTarget;

  const { onUpdateResourceAllocation } = useResourceAllocationUpdateHandler({
    allocationSort: allocationSort || {
      field: 'projectName',
      direction: SortDirection.Asc
    }
  });

  const periodDates =
    allocationPeriodEditTarget &&
    getAllocationPeriodEditorDateRange({
      periodDetails: allocationPeriodEditTarget
    });
  const onAllocationChange = useCallback(
    evt => {
      const scheduleTotalHours =
        evt.values?.scheduleRules &&
        getScheduleTotalHours({
          scheduleRules: evt.values.scheduleRules,
          quantity: 1
        });

      if (scheduleTotalHours === 0) {
        openReleaseResourcesDialog();

        return;
      }

      onUpdateResourceAllocation({
        allocation: {
          ...evt.values,
          requestedRoleUri: resourceAllocation.requestedRoleUri
        },
        existingResourceAllocation: {
          ...resourceAllocation,
          periodDetails: {
            startDate: periodDates.periodStartDate,
            endDate: periodDates.periodEndDate
          }
        }
      });
    },
    [
      onUpdateResourceAllocation,
      openReleaseResourcesDialog,
      periodDates.periodEndDate,
      periodDates.periodStartDate,
      resourceAllocation
    ]
  );

  return (
    <ResourceAllocationPeriodEditPopoverDetails
      chartStartDate={chartStartDate}
      chartEndDate={chartEndDate}
      scale={scale}
      allocationPeriodEditDetails={allocationPeriodEditTarget}
      onAllocationChange={onAllocationChange}
      isAllocationComplete
      handleAllocationPeriodClose={handleAllocationPeriodClose}
      setNextPeriod={setNextPeriod}
      setPreviousPeriod={setPreviousPeriod}
    />
  );
};

EditQuickAllocationPeriod.propTypes = {
  scale: PropTypes.string,
  handleAllocationPeriodClose: PropTypes.func,
  setPreviousPeriod: PropTypes.func,
  setNextPeriod: PropTypes.func,
  allocationPeriodEditTarget: PropTypes.object,
  chartStartDate: PropTypes.object,
  allocationSort: PropTypes.object,
  chartEndDate: PropTypes.object,
  openReleaseResourcesDialog: PropTypes.func
};

export default EditQuickAllocationPeriod;
